import {makeApiRequest} from './api.js';

const debounce = (func, delay) => {
	let timer;
	return (...args) => {
		clearTimeout(timer);
		timer = setTimeout(() => {
			func(...args);
		}, delay);
	};
};

// Make API request only if delay is passed since the last input change
const debouncedApiRequest = debounce(makeApiRequest, 300);
/**
 * For input change the slider track position is changed and API request will be made to fetch new values
 * Also, the number input value is synchronized --> we use the number input value as source of truth
 */
const updateSliderTrack = (slider) => {
	const percentage = slider.value;
	slider.style.background = `linear-gradient(to right, #4A88E4 ${percentage}%, #4A88E4 ${percentage}%, #F0F7FF ${percentage}%, #F0F7FF ${100-percentage}%)`;

	if (slider.getAttribute('id') === 'core-input-slider') {
		document.getElementById('core-input-number').value = percentage;
	} else if (slider.getAttribute('id') === 'ultimate-input-slider') {
		document.getElementById('ultimate-input-number').value = percentage;
	}
	// Make API request
	debouncedApiRequest();
}

/**
 * User can make manual input changes in the range 0...100. Input will be used to change sliders and make API request
 * @param input
 */
const handleInputChange = (input) => {
	if (input.value === '') {
		return;
	}

	if (input.id === 'core-input-number') {
		const slider = document.getElementById('core-input-slider');
		slider.value = input.value;
		updateSliderTrack(slider);
	} else if (input.id === 'ultimate-input-number') {
		const slider = document.getElementById('ultimate-input-slider');
		slider.value = input.value;
		updateSliderTrack(slider);
	}
};

/**
 * User can increase input value with buttons
 * @param modifier
 */
const handleQuantityIncrease = (modifier) => {
	if (modifier.getAttribute('data-plan') === 'core') {
		const slider = document.getElementById('core-input-slider');
		slider.value++;
		updateSliderTrack(slider);
	} else if (modifier.getAttribute('data-plan') === 'ultimate') {
		const slider = document.getElementById('ultimate-input-slider');
		slider.value++;
		updateSliderTrack(slider);
	}
}

/**
 * User can decrease input value
 * @param modifier
 */
const handleQuantityDecrease = (modifier) => {
	if (modifier.getAttribute('data-plan') === 'core') {
		const slider = document.getElementById('core-input-slider');
		slider.value--;
		updateSliderTrack(slider);
	} else if (modifier.getAttribute('data-plan') === 'ultimate') {
		const slider = document.getElementById('ultimate-input-slider');
		slider.value--;
		updateSliderTrack(slider);
	}
}

function showTooltip(event) {
	const tooltip = event.target.querySelector('.pricing-calculator__discounts-tooltip');
	tooltip.style.display = 'block';
}

function hideTooltip(event) {
	const tooltip = event.target.querySelector('.pricing-calculator__discounts-tooltip');
	tooltip.style.display = 'none';
}

document.addEventListener('DOMContentLoaded', () => {
	// Track slider change
	const sliders = document.querySelectorAll('.pricing-calculator__slider-range');
	if (sliders) {
		sliders.forEach(slider => {
			slider.addEventListener('input', (event) => {
				updateSliderTrack(event.target);
			});
		});
	}
	// Track number input change
	const numberInputs = document.querySelectorAll('.pricing-calculator__number-input');
	if (numberInputs) {
		numberInputs.forEach(input => {
			input.addEventListener('input', (event) => {
				handleInputChange(event.target);
			});
		});
	}
	// Track increase/decrease buttons
	const increaseButtons = document.querySelectorAll('.pricing-calculator__quantity-modifier--increase');
	if (increaseButtons) {
		increaseButtons.forEach(button => {
			button.addEventListener('click', (event) => {
				handleQuantityIncrease(event.target);
			})
		})
	}
	const decreaseButtons = document.querySelectorAll('.pricing-calculator__quantity-modifier--decrease');
	if (decreaseButtons) {
		decreaseButtons.forEach(button => {
			button.addEventListener('click', (event) => {
				handleQuantityDecrease(event.target);
			})
		})
	}
	// Track toggle button change (yearly or monthly term)
	const termToggleButtons = document.querySelectorAll('.pricing-calculator__toggle');
	if (termToggleButtons) {
		termToggleButtons.forEach(button => {
			button.addEventListener('click', (event) => {
				termToggleButtons.forEach(button => {
					button.classList.remove('pricing-calculator__toggle--active');
				});
				event.target.classList.add('pricing-calculator__toggle--active');
				makeApiRequest();
			});
		})
	}

	// Show or hide tooltip
	const discounts = document.querySelectorAll('.pricing-calculator__discounts');
	if (discounts) {
		discounts.forEach((discount) => {
			discount.addEventListener('mouseenter', (event) => {
				showTooltip(event);
			});
			discount.addEventListener('mouseleave', (event) => {
				hideTooltip(event);
			})
		})
	}
});

document.addEventListener("DOMContentLoaded", function() {
	// Check if the element with class "pricing-calculator" exists
	if (document.querySelector(".pricing-calculator")) {
		// Call debouncedApiRequest if the element exists
		debouncedApiRequest();
	}
});
